// src/store/actionTypes.ts
export const SET_PARTICIPANT_DATA = 'SET_PARTICIPANT_DATA';
